import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Well } from '../../../../components/Well';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { fetchKanbanBoard, performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { SetBVIDone } from './SetBVIDone';
import { GET_MY } from '../../../../containers/App/constants';

const Container = styled.div``;

const STATE = {
  loading: false,
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class BVIUploadCellComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.reset.bind(this));
    this.setState({ loading: true });
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  renderApprove() {
    if (!this.state.approve) return null;

    if (this.state.loading)
      return (
        <Modal>
          <Loader />
        </Modal>
      );

    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.BVIUpload.modal.title')}>
        Blijft hij hier hangen? <br />
        Zorg dat het BVI document en de gegevens in Helga goed staan en klik op 'confirm'
        <ModalControls>
          <SetBVIDone vehicle={this.vehicle} onComplete={this.reset.bind(this)} />
          <Button
            isPrimary
            onClick={() => {
              this.confirm();
            }}
          >
            {this.lbl('confirm')}
          </Button>

          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <CellButtons>
            <Loader small />
            <>
              <CellButton
                onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
              >
                <View />
              </CellButton>

              {/* <CellButton onClick={() => this.toHelgaVehicle(vehicle.helga_id)}>
                <img height="23" src="/public/helga_icon.svg" />
              </CellButton> */}
            </>
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

BVIUploadCellComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(callback) {
      dispatch({
        type: GET_MY,
        path: `/boards/helga-bvi-document-upload/${ownProps.cell.vehicle.id}`,
        post: {},
        putOnComplete: [fetchKanbanBoard(ownProps.board_id)],
        callback,
      });

      //dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BVIUploadCell = compose(
  withConnect,
  withRouter,
)(BVIUploadCellComp);
